import { SectionWithAssetListWithAssetPageSchema } from 'cms/schemaTypes/staticPages/documents/sectionWithAssetListWithAsset'
import Image from 'next/image'

import { urlFor } from 'lib/sanity/image'
import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import FormattedText from 'shared/ui/FormattedText'

import { SectionContainer, SectionTitle } from '../landings/styles'

import styles from './HowToRegisterMarketingSection.module.scss'

interface HowToRegisterMarketingSectionProps {
  content: SectionWithAssetListWithAssetPageSchema
}

const HowToRegisterMarketingSection = ({
  content
}: HowToRegisterMarketingSectionProps) => {
  return (
    <SectionContainer $condensed>
      <SectionTitle className={styles.sectionTitle}>
        <FormattedText text={content.header} />
      </SectionTitle>
      <div className={styles.contentContainer}>
        <div className={styles.contentWrapper}>
          <ul className={styles.itemsWrapper}>
            {content.sectionList.map(item => (
              <li key={item.key} className={styles.item}>
                <Image
                  src={urlFor(
                    'image' in item ? item.image.asset.asset : ''
                  ).url()}
                  alt={'image' in item ? item.image.alt : ''}
                  width={36}
                  height={36}
                />
                <CustomPortableText value={item.content || []} />
              </li>
            ))}
          </ul>
          <div className={styles.disclaimer}>
            <CustomPortableText value={content.content || []} />
          </div>
        </div>
        <div className={styles.imageWrapper}>
          <h3 className={styles.imageText}>{content.image.alt}</h3>
          <Image
            src={urlFor(content.image.asset.asset).url()}
            alt={content.image.alt}
            width={800}
            height={800}
            quality={90}
            sizes={'(max-width: 764px) 100vw, (max-width: 1024px) 250px, 500px'}
          />
        </div>
      </div>
    </SectionContainer>
  )
}

export default HowToRegisterMarketingSection
